export default "__VITE_ASSET__BSlY0SHt__"